export const COMPANIES_REQUESTED = 'COMPANIES_REQUESTED'
export const COMPANIES_RECEIVED = 'COMPANIES_RECEIVED'
